export const serviceItemActionTypes = {
   Add:"Add",
   Delete:"Delete",
   Edit:"Edit",
   Clear:"Clear"
};